<div *ngIf="service()">
  <div>
    <h2 class="page-details-title-style">Service {{ service()?.id }}</h2>
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab label="General Info">
      <div class="filter__fields">
        <mat-card class="mat-elevation-z8">
          <mat-card-content>
            <mat-grid-list [cols]="2" gutterSize="10px" rowHeight="90">
              <mat-grid-tile>
                <read-only-form-field title="Service ID" [value]="service()?.id?.toString()" testId="kt-service-id" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Trip Reference" [value]="service()?.tripReference" testId="kt-service-trip-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Product Type" [value]="service()?.productTypeName" testId="kt-service-product-type" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Service Name" [value]="service()?.serviceName" testId="kt-service-name" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor" [value]="service()?.vendorName" testId="kt-service-vendor" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Sub-Vendor" [value]="service()?.subVendorName" testId="kt-service-sub-vendor" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor Reference" [value]="service()?.vendorReference" testId="kt-service-vendor-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Travelers" [value]="service()?.travelers" testId="kt-service-travelers" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Quoted Cost" [value]="service()?.quotedCost?.toString()" testId="kt-service-quoted-cost" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Actual Cost" [value]="service()?.actualCost?.toString()" testId="kt-service-actual-cost" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Currency" [value]="service()?.currencyCode" testId="kt-service-currency" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Total Units" [value]="service()?.totalUnits?.toString()" testId="kt-service-total-units" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Start Date" [value]="service()?.serviceStartDate | date:'M/dd/yyyy'" testId="kt-service-start-date" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="End Date" [value]="service()?.serviceEndDate | date:'M/dd/yyyy'" testId="kt-service-end-date" />
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
